import { Injectable } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Injectable()
export class PhotocodeTemplateForm {

  constructor(private formBuilder: FormBuilder) {
  }

  public buildForm(): FormGroup {
    return this.formBuilder.group({
      name: [ '', Validators.required ],
      fontFileName: [ '', Validators.required ],
      watermarkFileName: [ '', Validators.required ],
      logoFileName: [ '', Validators.required ],
      templateFileName: [ '', Validators.required ],
      isDefault: [ false ],
    });
  }
}
